export default __webpack_public_path__ + "static/media/company_logo.137eafc3.png";